import { withInstall } from '@jdesign-vue/utils'
import Calendar from './src/calendar.vue'

export const JdCalendar = withInstall(Calendar)
export default JdCalendar

export * from './src/calendar'
export type {
  CalendarDateTableInstance,
  DateTableInstance,
  CalendarInstance,
} from './src/instance'
